import { render } from "./AdS.vue?vue&type=template&id=5702695d&scoped=true"
import script from "./AdS.vue?vue&type=script&lang=js"
export * from "./AdS.vue?vue&type=script&lang=js"

import "./AdS.vue?vue&type=style&index=0&id=5702695d&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5702695d"]])

export default __exports__